import { render, staticRenderFns } from "./GamesCalendar.vue?vue&type=template&id=25d643b0&"
import script from "./GamesCalendar.vue?vue&type=script&lang=js&"
export * from "./GamesCalendar.vue?vue&type=script&lang=js&"
import style0 from "./GamesCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports